import API from '@/models/API';
import router from '@/routes';

let storesType = () => {
  const panelType = ((router?.history.current.path || '').split('/') || [])[2];
  switch (panelType) {
    case 'loyaltyPanel':
      return 'companies';
    case 'storePanel':
      return 'stores';
    case 'supplierPanel':
      return 'suppliers';
    default:
      return 'stores';
  }
};

export default class ExportLinks {
  static getExportedFile = (key) =>
    API.get(`/${storesType()}/${localStorage.getItem('storeId')}/export/${key}`);

  static exportFile = (key, query, body) =>
    API.post(`/${storesType()}/${localStorage.getItem('storeId')}/export/${key + query}`, body);

  static deleteExportedFile = (key, id) =>
    API.delete(`/${storesType()}/${localStorage.getItem('storeId')}/export/${key}/${id}`);
}
